module.exports = __webpack_public_path__ + "img/color-up-icon.74855a36.svg";